<script lang="ts">
  import {onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import editorStore from '../../../../lib/editor/editor.store';
  import {user} from '@/store';
  import {tooltip} from '../../../../actions/tippy-action';
  import editorInstance from '../../../../lib/editor/editor';
  import {createImageElement} from '../../../../lib/editor/helpers';
  import {get} from 'lodash';

  let isShowing = writable(true);
  let rootComponent: any;
  let targetElement: HTMLElement | null;
  editorStore.subscribe(store => {
    if (store.rootComponent) {
      rootComponent = store.rootComponent;
      targetElement = store.activeComponent as HTMLElement;
      if (!targetElement) return isShowing.set(false);
      else {
        getComputedStyle(targetElement).display === 'none' ? isShowing.set(false) : isShowing.set(true);
        // isShowing.set(!targetElement.classList.contains('!hidden'));
      }
    }
  });

  function createLogo() {
    const finalImage = rootComponent.querySelector('#finalImageToExport');
    if (!finalImage) return;
    const src = $user.brandKit?.logoUrl || '';
    const logoElement = createImageElement(src);
    logoElement.setAttribute('data-amelement', 'logo');
    editorInstance.addComponent(logoElement, true);
  }

  function onClick() {
    isShowing.update(value => {
      console.log(targetElement);
      if (targetElement) {
        if (!value) {
          // targetElement.classList.remove("!hidden");
          targetElement.style.display = 'block';
        } else {
          // targetElement.classList.add("!hidden");
          targetElement.style.display = 'none';
        }
      }

      return !value;
    });
  }

  function deleteImage() {
    editorInstance.history.addHistory('Delete Element');
    targetElement?.remove();
    editorStore.setActiveComponent(null);
  }

  $: cssClass = $isShowing ? 'fa-eye' : 'fa-eye-slash';
</script>

{#if $editorStore.rootComponent}
  <div
    class="flex h-full cursor-pointer items-center justify-center rounded-md px-2 text-center hover:bg-gray-100"
    use:tooltip={'Show/Hide'}
    on:click|stopPropagation|preventDefault={onClick}
    on:keypress={onClick}
  >
    <i class="fa {cssClass}" />
  </div>
{/if}
{#if targetElement?.getAttribute('data-amelement') === 'stamp'}
  <div class="flex h-full items-center" on:click={deleteImage} on:keypress={deleteImage}>
    <div class="cursor-pointer p-1 text-dark hover:bg-gray-100">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </div>
  </div>
{/if}
